import * as ng from "@angular/core";
import {environment} from "../../env/environment";
import {CanActivate} from "@angular/router";

@ng.Injectable()
export class NotProductionGuard implements CanActivate {

  canActivate(): boolean {
    if (environment.production) {
      window.location.href = "https://live.mag2.com/s/about";
    }
    return true
  }

}
